import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", function () {
    const sliderElements = document.querySelectorAll('.achievement-block__slider');

    sliderElements.forEach((sliderElement) => {
        let achievementSlider;

        function initializeSplide() {
            if (sliderElement.splide) {
                sliderElement.splide.destroy();
            }

            achievementSlider = new Splide(sliderElement, {
                type: 'loop',
                perPage: 3,
                perMove: 1,
                gap: '30px',
                arrows: true,
                pagination: false,
                focus: 'center',
                breakpoints: {
                    1024: {
                        perPage: 2,
                        padding: { right: '5%', left: '5%' },
                    },
                    667: {
                        perPage: 1,
                        padding: { right: '15%', left: '15%' },
                        gap: '10px',
                    },
                },
            });

            achievementSlider.on('mounted move', function () {
                achievementSlider.Components.Elements.slides.forEach((slide, index) => {
                    const isActive = index === achievementSlider.index;
                
                    if (isActive) {
                        slide.removeAttribute('aria-hidden'); 
                    } else {
                        slide.removeAttribute('aria-hidden'); 
                    }

                    slide.querySelectorAll('a, button, input, textarea, select').forEach(el => {
                        el.setAttribute('tabindex', isActive ? '0' : '-1');
                    });
                });
            });

            achievementSlider.mount();
            sliderElement.splide = achievementSlider;
        }

        initializeSplide();
        window.addEventListener('resize', initializeSplide);
    });
});

